import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_fail_to_collect_and_forward_wrkrs_contributions_to'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_fail_to_collect_and_forward_wrkrs_contributions_to',
  name: 'Does the facility fail to collect and forward workers\' contributions to any of the following social insurance or social security programs in line with legal requirements? (SELECT all that apply with an "X")',
  description:
    'Consult applicable legal requirements before answering this question. \r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'PENSION_PROVIDENT_FUND',
      text: 'Pension/ Provident fund',
      externalIds: [
        {
          id: 'wb-wage-67',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MEDICAL',
      text: 'Medical',
      externalIds: [
        {
          id: 'wb-wage-68',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORK_RELATED_INJURY_ILLNESS_DEATH',
      text: 'Work-related injury/ illness/ death',
      externalIds: [
        {
          id: 'wb-wage-69',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'UNEMPLOYMENT',
      text: 'Unemployment',
      externalIds: [
        {
          id: 'wb-wage-70',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'MATERNITY',
      text: 'Maternity',
      externalIds: [
        {
          id: 'wb-wage-71',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'wb-wage-72',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'wb-wage-73f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'PENSION_PROVIDENT_FUND',
                'MEDICAL',
                'WORK_RELATED_INJURY_ILLNESS_DEATH',
                'UNEMPLOYMENT',
                'MATERNITY',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-wage-66',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 8990,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
